import { ChangeDetectorRef, ElementRef, EventEmitter, OnInit } from '@angular/core';
import * as moment from "moment";
var dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}$/;
var propraietrayToJson = function () {
    return moment(this).format('YYYY-MM-DD\\THH:mm:ss.SSS');
};
var ɵ0 = propraietrayToJson;
var datesParser = function reviver(key, value) {
    if (typeof value === "string" && dateFormat.test(value)) {
        return new Date(value);
    }
    return value;
};
var ɵ1 = datesParser;
var WebFormContainerComponent = /** @class */ (function () {
    function WebFormContainerComponent(sanitizer, changeDetector, patientAccountSvc, intlServicePP, tokenProvider, ssoTokenService) {
        this.sanitizer = sanitizer;
        this.changeDetector = changeDetector;
        this.patientAccountSvc = patientAccountSvc;
        this.intlServicePP = intlServicePP;
        this.tokenProvider = tokenProvider;
        this.ssoTokenService = ssoTokenService;
        this.dataValidated = new EventEmitter();
        this.dataReceived = new EventEmitter();
        this.onLanguageChanged = new EventEmitter();
        this.loadCurrentPatient = false;
        this.webFormReady = false;
        this.languageChanged = false;
    }
    WebFormContainerComponent.prototype.ngOnInit = function () {
        if (window.addEventListener) {
            window.addEventListener('message', this.receiveMessageFromIFrame.bind(this), false);
        }
        else {
            window.attachEvent('onmessage', this.receiveMessageFromIFrame.bind(this));
        }
    };
    Object.defineProperty(WebFormContainerComponent.prototype, "URL", {
        set: function (url) {
            var _this = this;
            this.webFormURL = url;
            this.intlServicePP.getUsedLanguageObservable().subscribe(function (lang) {
                if (lang) {
                    if (_this.selectedLanguageKey !== lang.languageKey) {
                        // if web form already loaded get its data before reloading it
                        if (_this.webFormReady) {
                            _this.languageChanged = true;
                            _this.onLanguageChanged.emit();
                            _this.getData();
                        }
                        else {
                            _this.setUrl(_this.webFormURL, lang.languageKey);
                        }
                        _this.selectedLanguageKey = lang.languageKey;
                    }
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    WebFormContainerComponent.prototype.setData = function (patient) {
        if (patient) {
            if (Date.prototype.toJSON !== propraietrayToJson) {
                Date.prototype.toJSON = propraietrayToJson;
            }
            this.sendMessageToWebFormFrame({ action: 'SET_PATIENT_DATA', data: JSON.stringify(patient.model.patient) });
        }
        else {
            this.sendMessageToWebFormFrame({ action: 'CREATE_EMPTY_PATIENT', data: '' });
        }
    };
    WebFormContainerComponent.prototype.getData = function () {
        this.sendMessageToWebFormFrame({ action: 'GET_PATIENT_DATA', data: '' });
    };
    WebFormContainerComponent.prototype.setUrl = function (url, languageKey) {
        var _this = this;
        if (this.tokenProvider.isAuthenticated()) {
            this.ssoTokenService.getSSOTokenForPatient().subscribe(function (token) {
                if (languageKey) {
                    url = url + '&language=' + _this.intlServicePP.usedLanguage.languageKey;
                }
                _this.IFrameSrc = _this.sanitizer.bypassSecurityTrustResourceUrl(url.replace("{SSO_TOKEN}", token));
                _this.changeDetector.markForCheck();
            });
        }
        else {
            this.ssoTokenService.getSSOToken().subscribe(function (token) {
                if (languageKey) {
                    url = url + '&language=' + _this.intlServicePP.usedLanguage.languageKey;
                }
                _this.IFrameSrc = _this.sanitizer.bypassSecurityTrustResourceUrl(url.replace("{SSO_TOKEN}", token));
                _this.changeDetector.markForCheck();
            });
        }
    };
    WebFormContainerComponent.prototype.receiveMessageFromIFrame = function (event) {
        var iframeDocument = this.Iframe.nativeElement.contentWindow;
        if (event.source === iframeDocument) {
            if (event.data) {
                var message = event.data;
                switch (message.action) {
                    case 'READY':
                        if (this.loadCurrentPatient) {
                            this.sendMessageToWebFormFrame({ action: 'LOAD_PORTAL_PATIENT', data: '' });
                        }
                        else {
                            this.sendMessageToWebFormFrame({ action: 'CREATE_EMPTY_PATIENT', data: '' });
                        }
                        break;
                    case 'EMPTY_PATIENT_CREATED':
                        this.webFormReady = true;
                        if (this.patient) {
                            // if web form was reloaded (e.g. as result of selected language change)
                            this.setData(this.patient);
                        }
                        break;
                    case 'PATIENT_DATA_VALIDATED':
                        this.dataValidated.emit(message.data);
                        break;
                    case 'PATIENT_DATA_SENT':
                        this.patient = JSON.parse(message.data, datesParser);
                        if (this.languageChanged) {
                            // if user changed selected language just reload the web form
                            this.setUrl(this.webFormURL, this.selectedLanguageKey);
                        }
                        else {
                            this.dataReceived.emit(this.patient);
                        }
                        this.languageChanged = false;
                        break;
                    default:
                        break;
                }
            }
        }
    };
    WebFormContainerComponent.prototype.sendMessageToWebFormFrame = function (msg) {
        var iframeDocument = this.Iframe.nativeElement.contentWindow;
        if (iframeDocument) {
            iframeDocument.postMessage(msg, '*');
        }
    };
    return WebFormContainerComponent;
}());
export { WebFormContainerComponent };
export { ɵ0, ɵ1 };
